export default __webpack_public_path__ + "static/media/281954.4ca6ac51.png";